export default "__VITE_ASSET__CiRemb1M__"